module.exports = __webpack_public_path__ + "static/media/express_logo.b7ec2c5f.png";